import {Component, Input, OnInit} from '@angular/core';
import {BasePageComponent} from "../../../base-page.component";
import {DocumentService} from "../../../services/domain/document.service";
import {RegistryService} from "../../../services/domain/registry.service";
import {saveAs} from "file-saver";
import {DocumentiTipoExtraInfoDetailList, FilePreviewViewModel} from "../../../models/documenti.models";

@Component({
  selector: 'app-document-show',
  templateUrl: './document-show.component.html',
  styleUrls: ['./document-show.component.css'],
  providers : [DocumentService, RegistryService]
})
export class DocumentShowComponent extends BasePageComponent implements OnInit{
  constructor(private documentService : DocumentService,
              private registryService : RegistryService) {
    super();

  }

  @Input()public src: string = "";
  @Input()public blob : Blob = new Blob();
  @Input()public fileName : string = "";
  @Input()public FileIdEnc : string | null = null;

  public fileDetailRequest : FilePreviewViewModel = new FilePreviewViewModel();
  public lstKeyValueDocumentInfo : DocumentiTipoExtraInfoDetailList[] = [];

  ngOnInit(): void {
    if(this.FileIdEnc != "" && this.FileIdEnc != null){
      this.fileDetailRequest.Id = this.FileIdEnc;
      this.getFileDetail();
    }
  }

  public print() {
    const blobUrl = window.URL.createObjectURL((this.blob));
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = blobUrl;
    document.body.appendChild(iframe);
    if(iframe.contentWindow != null)
      iframe.contentWindow.print();
  }

  public getFileDetail(){
    this.asyncCall(() => this.documentService.getFileDetail(this.fileDetailRequest), response => {
      this.lstKeyValueDocumentInfo = response.Items || [];
    });
  }

  public download(){
    saveAs(this.blob, this.fileName);
  }

}
